import { TopMenuPath } from '@web-common/conf/waimao/constant';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiHolder, apis } from 'api';
import { ADMIN_PINNED_MENU_LIST, IGNORE_PINNED_MENU_LIST, ULTIMATE_VERSION_AND_ADMIN_MENU_LIST } from '@web-common/conf/waimao/pinnedIgnoreMenu';
import { getIsEdmAdmin } from '@web-common/state/reducer/privilegeReducer';
const edmMenuApi = apiHolder.api.requireLogicalApi(apis.edmMenusApiImpl);
const getIsPinnedMenuAvailable = (data, conf) => {
    if (IGNORE_PINNED_MENU_LIST.includes(data.value)) {
        return false;
    }
    if (ULTIMATE_VERSION_AND_ADMIN_MENU_LIST.includes(data.value) && (!conf.isUltimateVersion || !conf.isAdmin)) {
        return false;
    }
    return conf.isAdmin || !ADMIN_PINNED_MENU_LIST.includes(data.value);
};
const formatAllPinnedMenus = (list, conf) => {
    if (Array.isArray(list) && list.length > 0) {
        const result = [];
        list.forEach(({ menuName, menuLabel, subMenuItems }) => {
            const subItems = formatAllPinnedMenus(subMenuItems, conf);
            if (subItems && subItems.length === 0) {
                return;
            }
            const available = getIsPinnedMenuAvailable({ label: menuName, value: menuLabel }, conf);
            if (!available) {
                return;
            }
            result.push({
                label: menuName,
                value: menuLabel,
                subItems: subItems || [],
            });
        });
        return result;
    }
    return null;
};
export const doGetPinnedMenus = createAsyncThunk('webEntryWmReducer/doGetPinnedMenus', async (_params, { getState }) => {
    const res = await edmMenuApi.getPinnedMenus({
        productId: 'fastmail',
        productVersionId: 'professional',
    });
    if (Array.isArray(res)) {
        const rootState = getState();
        const isUltimateVersion = rootState.privilegeReducer.ultimateVersion;
        const isAdmin = getIsEdmAdmin(rootState.privilegeReducer);
        return res
            .map(each => ({
            label: each.menuName,
            value: each.menuLabel,
        }))
            .filter(v => getIsPinnedMenuAvailable(v, { isUltimateVersion, isAdmin }));
    }
    return [];
});
export const doGetAllPinnedMenus = createAsyncThunk('webEntryWmReducer/doGetAllPinnedMenus', async (_params, { getState }) => {
    const res = await edmMenuApi.getAllPinnedMenus({
        productId: 'fastmail',
        productVersionId: 'professional',
    });
    if (Array.isArray(res)) {
        const rootState = getState();
        const isUltimateVersion = rootState.privilegeReducer.ultimateVersion;
        const isAdmin = getIsEdmAdmin(rootState.privilegeReducer);
        return formatAllPinnedMenus(res, { isUltimateVersion, isAdmin }) || [];
    }
    return [];
});
const initialState = {
    topMenu: [],
    lastPageInModule: {},
    cachedTabs: [],
    pinnedMenusUpdateFlag: true,
    pinnedMenus: undefined,
    allPinnedMenu: undefined,
    path: '',
};
const webEntryWmReducerSlice = createSlice({
    name: 'webEntryWmReducer',
    initialState,
    reducers: {
        setPinnedMenusUpdateFlag(state, action) {
            state.pinnedMenusUpdateFlag = action.payload;
        },
        setPageInModuleMap(state, action) {
            const { mpMap, key } = action.payload;
            state.lastPageInModule[key] = mpMap[key];
        },
        setCachedTabs(state, action) {
            const { moduleName, page, params } = action.payload;
            if ([
                TopMenuPath.worktable,
                TopMenuPath.wmData,
                TopMenuPath.intelliMarketing,
                TopMenuPath.coop,
                'emailInquiry',
                TopMenuPath.personal,
                TopMenuPath.enterpriseSetting,
                TopMenuPath.site,
                TopMenuPath.systemTask,
                TopMenuPath.noviceTask,
                'whatsAppRegister',
                TopMenuPath.wa,
                TopMenuPath.notificationCenter,
                TopMenuPath.aiStaff,
                TopMenuPath.aiTeam,
            ].indexOf(moduleName) === -1)
                return;
            const item = state.cachedTabs.find(item => item.tab === moduleName);
            if (item) {
                item.page = page;
                item.query = params;
                state.cachedTabs = [...state.cachedTabs];
            }
            else {
                state.cachedTabs = [...state.cachedTabs, { tab: moduleName, page, query: params }];
            }
        },
        updatePinnedMenus(state, action) {
            const { menus = [] } = action.payload;
            state.pinnedMenus = [...menus];
        },
        updatePath(state, action) {
            const { path = '' } = action.payload;
            state.path = path;
        },
    },
    extraReducers: builder => {
        builder.addCase(doGetPinnedMenus.fulfilled, (state, action) => {
            state.pinnedMenus = action.payload || [];
        });
        builder.addCase(doGetAllPinnedMenus.fulfilled, (state, action) => {
            state.allPinnedMenu = action.payload || [];
        });
    },
});
export const WebEntryWmActions = webEntryWmReducerSlice.actions;
export default webEntryWmReducerSlice.reducer;
